import { observable, runInAction } from "mobx";
import { API } from "src/Services/Api/Api";
import { RootStore } from "../Root/RootStore";

export interface ITenant {
    id: string;
    tenantCompanyName: string;
    contactName: string;
    contactEmail: string;
    phone: string;
    hostName: string;
    webSite: string;
    address1: string;
    address2: string;
    logoPathNameApp: string;
    logoPathNameReport: string;
    active: boolean;
    primaryColor: string;
    secondaryColor: string;
    lineBreakColor: string;
    textOnPrimaryColor: string;
    textOnSecondaryColor: string;
}

class TenantApi {
    private API: API;
    constructor(api: API) {
        this.API = api;
    }

    public getTenant():Promise<ITenant> {
        return this.API.get('/tenant');
    }

    public getReportLogo(url: string) {
        return this.API.getFetchWithHeaders(url);
    }
}

export default class TenantStore {
    
    @observable public tenant: ITenant;
    @observable public logoPathNameApp: string;
    @observable public logoPathNameReport: string;
    @observable public iconColor: string = '#ffa500';
    @observable public onBrandIconColor: string = '#ffffff';
    
    private api: TenantApi;
    private RootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.RootStore = rootStore;
        this.api = new TenantApi(this.RootStore.Api);
    }

    public async getTenant() {
        const tenant = await this.api.getTenant();
        await fetch(tenant.logoPathNameReport);
        runInAction(() => {
            this.tenant = tenant;
            this.logoPathNameApp = tenant.logoPathNameApp;
            this.logoPathNameReport = tenant.logoPathNameReport;
            this.iconColor = tenant.primaryColor;
            this.onBrandIconColor = tenant.textOnPrimaryColor;
        });
        this.setTenantColors();
        return tenant;
    }

    public async setTenantColors() {
        const root = document.documentElement;
        root.style.setProperty('--primary-color', this.tenant.primaryColor);
        root.style.setProperty('--secondary-lighter-20', this.LightenDarkenColor(this.tenant.secondaryColor, 20));
        root.style.setProperty('--secondary-lighter-30', this.LightenDarkenColor(this.tenant.secondaryColor, 30));
        root.style.setProperty('--secondary-color', this.tenant.secondaryColor);
        root.style.setProperty('--tertiary-color', this.LightenDarkenColor(this.tenant.secondaryColor, 20));
        root.style.setProperty('--button-color', this.tenant.secondaryColor);
        root.style.setProperty('--button-outline-color', this.LightenDarkenColor(this.tenant.secondaryColor, -20));
        root.style.setProperty('--text-on-button-color', this.tenant.textOnSecondaryColor);
        root.style.setProperty('--text-on-primary-color', this.tenant.textOnPrimaryColor);
        root.style.setProperty('--text-on-secondary-color', this.tenant.textOnSecondaryColor);
        root.style.setProperty('--text-on-sidebar-color', this.tenant.primaryColor);
        root.style.setProperty('--line-break-color', this.tenant.lineBreakColor);
    }

    public LightenDarkenColor(col: string, amt: number) {
    /* tslint:disable */ 
        let usePound = false;
      
        if (col[0] === "#") {
            col = col.slice(1);
            usePound = true;
        }
     
        const num = parseInt(col,16);
     
        let r = (num >> 16) + amt;
     
        if (r > 255) {
            r = 255;
        }
        else if (r < 0) {
            r = 0;
        } 
        let b = ((num >> 8) & 0x00FF) + amt;
     
        if (b > 255) {
            b = 255;
        } 
        else if (b < 0) {
            b = 0;
        }
     
        var g = (num & 0x0000FF) + amt;
     
        if (g > 255) {
            g = 255;
        }
        else if (g < 0) {
            g = 0;
        }
     
        return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
      
    }
}


// WEBPACK FOOTER //
// ./src/Stores/Tenant/TenantStore.ts